import {useRef} from "react";

export const useCallOnce = (call: () => void) => {
    const called = useRef(false);
    if (!called.current) {
        call();
        called.current = true;
    }
}

export const useCallOnce$ = () => {
    const called = useRef(false);
    return (call: () => void) => {
        if (!called.current) {
            call();
            called.current = true;
        }
    }
}
